import PresenterDetails from './PresenterDetails';

export default PresenterDetails;
